import { ApiGetRequest } from 'types';

export enum ECustomNotificationTarget {
  ALL = 'all',
  COMPANY_ADMINS = 'company_admins',
}

export enum ECustomNotificationModals {
  ADD = 'add',
  CONFIRM = 'confirm',
  DETAILS = 'details',
}

export enum ICustomNotificationModalAction {
  DELETE = 'delete',
}

export interface ICustomNotificationModalPayload {
  action?: ICustomNotificationModalAction;
}

export interface ICustomNotificationModal {
  type: ECustomNotificationModals;
  payload?: ICustomNotificationModalPayload;
}

export interface ICustomNotification {
  id: number;
  creator_name: string;
  message: string;
  target: ECustomNotificationTarget;
  link?: string | null;
  receive_count: number;
  read_count: number;
  click_count: number;
  delivery_date: string;
  is_sent: boolean;
}

export interface FetchCustomNotificationsPayload extends ApiGetRequest {
  filter_by_target?: string | null;
  filter_by_link?: boolean | null;
  filter_by_sent?: boolean | null;
}

export interface AddCustomNotificationPayload {
  message: string;
  target: ECustomNotificationTarget;
  link: string | null;
  delivery_date: string;
}

export interface DeleteCustomNotificationPayload {
  id: number;
}
